import type { CSSProperties, FC, SVGProps } from "react"
import * as NucleoFillIcons from "nucleo-ui-fill-18"
import * as NucleoOutlineIcons from "nucleo-ui-outline-18"

import { LUCIDE_TO_NUCLEO_OUTLINE_18 } from "../icons/lucide-to-nucleo-map"

type Variant = "outline" | "fill"

interface Props {
	icon?: string | null
	className?: string
	style?: CSSProperties
	variant?: Variant
}

const FALLBACK_ROOT = "SquareArrowUpRight"
const STROKE_WIDTH = 1.5

function resolveNucleoComponent(
	root: string | null | undefined,
	variant: Variant,
): FC<SVGProps<SVGSVGElement>> {
	const target = root ?? FALLBACK_ROOT
	const pkg = variant === "fill" ? NucleoFillIcons : NucleoOutlineIcons
	const suffix = variant === "fill" ? "Fill18" : "Outline18"
	const exportName = `Icon${target}${suffix}` as keyof typeof pkg
	const Icon = pkg[exportName] as FC<SVGProps<SVGSVGElement>> | undefined
	if (Icon) return Icon
	const fallbackExport = `Icon${FALLBACK_ROOT}${suffix}` as keyof typeof pkg
	return pkg[fallbackExport] as FC<SVGProps<SVGSVGElement>>
}

export function resolveLucideIcon(
	icon: string | null | undefined,
	variant: Variant = "outline",
): FC<SVGProps<SVGSVGElement>> {
	const mapping = icon
		? LUCIDE_TO_NUCLEO_OUTLINE_18[
				icon as keyof typeof LUCIDE_TO_NUCLEO_OUTLINE_18
			]
		: undefined
	return resolveNucleoComponent(mapping?.root ?? icon, variant)
}

export const LUCIDE_ICON_STROKE_WIDTH = STROKE_WIDTH

export const LucideIcon: FC<Props> = ({
	icon,
	className,
	style,
	variant = "outline",
}) => {
	const Icon = resolveLucideIcon(icon, variant)
	return <Icon className={className} style={style} strokeWidth={STROKE_WIDTH} />
}
